export default __webpack_public_path__ + "static/SFMono-MediumItalic-08569d8e67fa575091519089768d2135.woff2";